<template>
  <div class="pb100">
    <volunteerdata/>
    <div class="container">
      <div>{{ getsearchMenu(menu) }}</div>
      <ul class="ul1 clearfix">
        <li @click="registerVolunteer">
          <a class="clearfix">
            <img src="../../assets/common/images/icon-zyzfc.png" alt="">
            <div class="txt">
              <h3>志愿者报名</h3>
              <p>Volunteer sign up</p>
              <span>我要报名</span>
            </div>
          </a>
        </li>
        <li>
          <router-link class="clearfix" :to="'volunteercommunity?columnId=' + volunteer.communityid">
            <img src="../../assets/common/images/icon-stzs.png" alt="">
            <div class="txt">
              <h3>志愿团队展示</h3>
              <p>Volunteer display</p>
              <span>了解详情 +</span>
            </div>
          </router-link>
        </li>
        <li>
          <router-link class="clearfix" :to="'volunteer?columnId=' + volunteer.volunteerid">
            <img src="../../assets/common/images/icon-zyzfc.png" alt="">
            <div class="txt">
              <h3>志愿者风采</h3>
              <p>Volunteer style</p>
              <span>了解详情 +</span>
            </div>
          </router-link>
        </li>
      </ul>
      <div class="pubtitle">
        <h2>志愿活动<span>/ Volunteer Activities</span></h2>
        <router-link :to="'volunteeractivity?columnId=' + volunteer.activityid">更多</router-link>
      </div>
      <ul class="ul-model1 clearfix">
        <li v-for="(item, index) in List" :key="index">
          <router-link :to="'/volunteeractivitydetail?columnId=' + item.menuId + '&id=' + item.id">
            <div class="imgbox">
              <img class="imgtop" :src="item.image" alt="">
            </div>
            <div class="txtbox">
              <h2 class="textover">{{ item.name }}</h2>
              <div class="descbox">
                <p class="textover">日期：<span>{{ item.activityDate }}</span></p>
                <p class="textover">地点：<span>{{ item.address }}</span></p>
                <p class="textover" v-if="item.initiator !== undefined && item.initiator !== ''">发起：<span>{{ item.initiator }}</span></p>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
      <div class="pubtitle">
        <h2>服务风采<span>/ Service Events</span></h2>
        <router-link :to="'activitystyle?columnId=' + volunteer.activitystyleid">更多</router-link>
      </div>
      <ul class="ul-model1 clearfix">
        <li v-for="(item, index) in List1" :key="index">
          <a @click.stop="detaillink(item)">
            <div class="imgbox">
              <img class="imgtop" :src="item.image" alt="">
            </div>
            <div class="txtbox">
              <h2 class="textover">{{ item.title }}</h2>
              <div class="descbox">
                <p class="textover">日期：<span>{{ item.publishTime }}</span></p>
                <p class="textover">社团：<span>{{ item.communityName }}</span></p>
              </div>
            </div>
          </a>
        </li>
      </ul>
      <div style="display: none;">
        <type-screen
          v-if="volunteer.volunteerid"
          modelType="volunteer"
          :menu-id="volunteer.volunteerid"
          @typedata="typeDataList"
          @typeObj="selectType"/>
      </div>
      <registervolunteer
        :menuId="volunteer.volunteerid"
        :centerDialogVisible="showregister"
        :politicalStateArr="politicalStateArr"
        :serviceTypeArr="serviceTypeArr"
        :serviceAreaArr="serviceAreaArr"
        @closeDiglog = "closeDiglog"
        />
    </div>
  </div>
</template>

<script>
import { vactivityList, activitystyle, isVolunteer } from '@/api/volunteer/index'
import volunteerdata from '@/view/volunteercenter/volunteerdata'
import registervolunteer from '@/view/volunteercenter/registervolunteer'
import typeScreen from '@/components/typescreen/index'
export default {
  name: 'volunteerindex',
  meta: {
    showHeader: true
  },
  components: {
    volunteerdata,
    registervolunteer,
    typeScreen
  },
  data () {
    return {
      Param: {
        fid: this.$cookie.get('culturalCloud_fid'),
        pageNum: 1,
        limit: 4,
        type: ''
      },
      List: [],
      listTotal: 0,
      Param1: {
        fid: this.$cookie.get('culturalCloud_fid'),
        pageNum: 1,
        limit: 12,
        type: ''
      },
      List1: [],
      listTotal1: 0,
      volunteer: {
        activityid: '',
        activitystyleid: '',
        communityid: '',
        volunteerid: ''
      },
      showregister: {
        ifshow: false
      },
      politicalStateArr: [],
      serviceTypeArr: [],
      serviceAreaArr: []
    }
  },
  computed: {
    menu () {
      return this.$store.state.menuTree.list
    }
  },
  mounted () {
    this.getList()
    this.getList1()
  },
  methods: {
    closeDiglog (val) {
      this.showregister.ifshow = val
    },
    /* 查询志愿者菜单ID */
    getsearchMenu (val) {
      if (val) {
        for (let i = 0; i < val.length; i++) {
          let item = val[i]
          if (item.backRouteId === 63) {
            this.volunteer.volunteerid = item.id
          }
          if (item.backRouteId === 64) {
            this.volunteer.communityid = item.id
          }
          if (item.backRouteId === 65) {
            this.volunteer.activityid = item.id
          }
          if (item.backRouteId === 66) {
            this.volunteer.activitystyleid = item.id
          }
          if (item.children && item.children.length > 0) {
            this.getsearchMenu(item.children)
          }
        }
        return this.currentId
      }
    },
    getList () {
      vactivityList(this.Param).then(res => {
        if (res.data.status === 0) {
          this.listTotal = res.data.totalSize
          this.List = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getList1 () {
      activitystyle(this.Param1).then(res => {
        if (res.data.status === 0) {
          this.listTotal1 = res.data.totalSize
          this.List1 = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    detaillink (item) {
      if (item.link !== undefined && item.link !== '') {
        window.open(item.link)
      } else {
        this.$router.push({path: '/activitystyledetail', query: {columnId: item.menuId, id: item.id}})
      }
    },
    /* 注册志愿者按钮 */
    registerVolunteer () {
      let _this = this
      isVolunteer(this.$cookie.get('culturalCloud_fid')).then(res => {
        if (res.data.rel) {
          _this.showregister.ifshow = true
        } else {
          // this.$message.error(res.data.message)
          console.log('res.data.message', res.data.message)
        }
      })
    },
    /* 筛选条件 */
    selectType (obj) {
      this.Param.politicalState = obj.politicalState
      this.Param.serviceType = obj.serviceType
      this.Param.serviceArea = obj.serviceArea
      this.Param.type = obj.customTypeId
      this.Param.pageNum = 1
      this.currentPage = 1
      this.getList()
    },
    typeDataList (val) {
      this.volunteertypeArr = val.dictType
      if (this.volunteertypeArr['zyzzzmm'].list.length > 0) {
        Object.assign(this.politicalStateArr, this.volunteertypeArr['zyzzzmm'].list)
      }
      if (this.volunteertypeArr['zyzfwlx'].list.length > 0) {
        Object.assign(this.serviceTypeArr, this.volunteertypeArr['zyzfwlx'].list)
      }
      if (this.volunteertypeArr['zyzfwqy'].list.length > 0) {
        Object.assign(this.serviceAreaArr, this.volunteertypeArr['zyzfwqy'].list)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ul1{
  margin: 0 -16px 35px -16px;
  li{
    width: 33.3333%;
    padding: 0 10px;
    float: left;
    height: 200px;
    a{
      display: block;
      background: #ebf3fe;
      img{
        display: block;
        float: left;
        padding-top: 30px;
        width: 50%;
      }
      .txt {
        padding: 30px 0px;
        margin-right: 26px;
        width: 160px;
        float: right;
        text-align: center;
        h3 {
          font-size: 24px;
        }
        p {
          color: #999999;
          margin: 15px 0 32px;
        }
        span {
          display: inline-block;
          width: 122px;
          height: 36px;
          border: solid 1px #dddddd;
          line-height: 36px;
          color: #999999;
        }
      }
    }
  }
}
.pubtitle{
  height: 50px;
  border-bottom: solid 1px #eaedf1;
  margin: 20px 0;
  position: relative;
  h2 {
    float: left;
    padding: 0 0 0 34px;
    background: url('~@/assets/common/icon/icon-volunteer.png') left top no-repeat;
    span {
      color: rgb(204, 204, 204);
      margin-left: 10px;
      font-size: 16px;
    }
  }
  &:after {
    position: absolute;
    display: block;
    height: 1px;
    background: #fff;
    width: 100%;
    content: '';
    left: 0;
    bottom: -2px;
  }
  a{
    color: #cccccc;
    margin-left: 10px;
    font-size: 12px;
    border: solid 1px #cccccc;
    border-radius: 4px;
    display: block;
    width: 48px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    position: absolute;
    right: 0;
    top: 4px;
    padding-right: 4px;
    &:after {
      position: absolute;
      display: block;
      content: '';
      width: 0;
      height: 0;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-left: 4px solid #ccc;
      right: 5px;
      top: 5px;
    }
  }
}
.ul-model1{
  margin: 0 -10px;
  li{
    padding: 0 10px 20px;
    a{
      border-radius: 6px;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/volunteercenter/index.vue